import { getHdFixedStarByKey } from '../../fixed-stars/hd-fixed-stars.metadata';

/**
 * Segment van een sternoot: platte tekst, of een klikbare sternaam die het
 * fixed-star-info-paneel van die side opent.
 */
export interface HdLocksKeysStarNoteSegment {
  readonly text: string;
  /** Side-nummer (1..66) wanneer dit segment een klikbare sternaam is. */
  readonly starSide?: number;
}

const STAR_TOKEN = /\{\{star:([a-z0-9-]+)\|([^}]+)\}\}/g;

/**
 * Parseert een i18n-tekst met `{{star:<key>|<label>}}`-tokens (bv. de
 * `starNote2027`-noten in de locks-keys-scope) naar segmenten voor de
 * template. Onbekende ster-keys vallen terug op platte tekst.
 */
export function parseHdLocksKeysStarNote(text: string): readonly HdLocksKeysStarNoteSegment[] {
  if (text === '') {
    return [];
  }
  const segments: HdLocksKeysStarNoteSegment[] = [];
  let lastIndex = 0;
  for (const match of text.matchAll(STAR_TOKEN)) {
    if (match.index > lastIndex) {
      segments.push({ text: text.slice(lastIndex, match.index) });
    }
    const side = getHdFixedStarByKey(match[1])?.side;
    segments.push(side != null ? { text: match[2], starSide: side } : { text: match[2] });
    lastIndex = match.index + match[0].length;
  }
  if (lastIndex < text.length) {
    segments.push({ text: text.slice(lastIndex) });
  }
  return segments;
}
